import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SkipToContent from '../ui/SkipToContent';
import RelatedProducts from '../RelatedProducts';

const Layout = ({ children, hideFooter = false }) => {
      return (
            <>
                  <SkipToContent />
                  <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950 transition-colors duration-300">
                        <Navbar />
                        <main id="main-content" className="flex-grow pt-16" role="main">
                              {children}
                              <RelatedProducts />
                        </main>
                        {!hideFooter && <Footer />}
                  </div>
            </>
      );
};

export default Layout;
